
import {Component, Vue, Prop} from 'vue-property-decorator';
import {AIMonitorApi} from '@/api';
import {frequencyAiTypes} from '@/js/aiConfig/aiconfig-list.helper';
@Component
export default class DataOverview extends Vue {
    @Prop({default: () => []}) schoolParams!: Array<string>;
    @Prop({default: ''}) ruleId!: string;
    @Prop({default: false}) isClass!: boolean;
    overViewObjectCount: any = {};
    overviewObject = [
        {text: '已使用AI能力', key: 'usedAI', unit: '个', desc: ''},
        {text: '未使用AI能力', key: 'noUsedAI', unit: '个', desc: ''},
        {
            text: '使用教师/教研数',
            key: 'numberOfUsedTeachers',
            unit: '人',
            desc: ''
        },
        {text: '使用学生数', key: 'numberOfUsedStudents', unit: '人', desc: ''}
    ];
    boxStyle = [
        {bar: '#47D075', bgc: '#F3FFF5'},
        {bar: '#1456ED', bgc: '#F2F8FF'},
        {bar: '#805CF2', bgc: '#F5F1FF'},
        {bar: '#FF5637', bgc: '#FFF8E6'},
        {bar: '#FF5637', bgc: '#FFF4F2'},
        {bar: '#b9b9bb', bgc: '#F7F8FA'}
    ];

    getData() {
        const url = this.isClass
            ? `/ecode/statistics/overview/class/${this.schoolParams[1]}`
            : `/ecode/statistics/overview/school/${this.schoolParams[0]}`;
        AIMonitorApi.getOverviewData({
            context: this,
            url,
            data: {ruleId: this.ruleId},
            success: (data: any, parameters: any) => {
                if (data.code === 0) {
                    this.overViewObjectCount = data.data;
                    this.overViewObjectCount.usedAI = data.data.usedAI.length;
                    this.overViewObjectCount.noUsedAI = frequencyAiTypes.length - data.data.usedAI;
                }
            }
        });
    }
    goDetails() {
        this.$router.push({name: 'school_AI_manage', params: {checked: '1'}});
    }
}
